var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContacts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1832_2648",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#474747"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1832_2648)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.62501 22C4.35835 22 4.11668 21.8917 3.90001 21.675C3.68335 21.4583 3.57501 21.2167 3.57501 20.95V18.325C3.57501 16.825 4.04168 15.5 4.97501 14.35C5.90835 13.2 7.10835 12.4667 8.57501 12.15C7.90835 12.6167 7.39168 13.2042 7.02501 13.9125C6.65835 14.6208 6.47501 15.3833 6.47501 16.2V20.95C6.47501 21.1333 6.50001 21.3167 6.55001 21.5C6.60001 21.6833 6.68335 21.85 6.80001 22H4.62501ZM8.30001 22C8.01668 22 7.77085 21.8958 7.56251 21.6875C7.35418 21.4792 7.25001 21.2333 7.25001 20.95V16.2C7.25001 15.0333 7.66251 14.0417 8.48751 13.225C9.31251 12.4083 10.3083 12 11.475 12H16.2C17.3667 12 18.3583 12.4083 19.175 13.225C19.9917 14.0417 20.4 15.0333 20.4 16.2V17.8C20.4 18.9667 19.9917 19.9583 19.175 20.775C18.3583 21.5917 17.3667 22 16.2 22H8.30001ZM12 9.9C10.9 9.9 9.96668 9.51667 9.20001 8.75C8.43335 7.98333 8.05001 7.05 8.05001 5.95C8.05001 4.85 8.43335 3.91667 9.20001 3.15C9.96668 2.38333 10.9 2 12 2C13.1 2 14.0333 2.38333 14.8 3.15C15.5667 3.91667 15.95 4.85 15.95 5.95C15.95 7.05 15.5667 7.98333 14.8 8.75C14.0333 9.51667 13.1 9.9 12 9.9Z",
    fill: "#474747"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContacts);
export default __webpack_public_path__ + "static/media/Contacts.5ace78ae7f50b56b3ce8ceab262337cf.svg";
export { ForwardRef as ReactComponent };